/**
 * Organization configuration constants
 * These constants are used throughout the organization configuration system
 */

/**
 * Feature flag constants for organization configuration.
 * These exact strings must be used in Clerk org publicMetadata.featureFlags (e.g. ['fund-management']).
 */
export const FEATURE_FLAGS = {
  /** Portfolio management features */
  PORTFOLIO_MANAGEMENT: 'portfolio-management',
  /** Fund management features (note: spelling is fund-management with an 'e') */
  FUND_MANAGEMENT: 'fund-management',
  /** Dynamic dashboard features */
  DYNAMIC_DASHBOARD: 'dynamic-dashboard',
} as const;

/**
 * Type for feature flag values
 */
export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
